/**
 * Permission that reveals the fuel-surcharge column on a hired equipment
 * submission (HE-F17 / HE-F18). Rate stays visible without it.
 * Fuel sits next to Rate and shows the fuels-table $/hr for the line date.
 * Markup is not collected here — it lives on the task / project costing.
 *
 * Assigned to Operations Coordinator, Ops Manager, and Admin (via the seed
 * matrix). Foreman / superintendent roles do not get this key.
 */
export const HIRED_EQUIPMENT_FINANCIALS_PERMISSION = 'submission:hired_equipment_financials';

/**
 * Lets the holder type a fuel surcharge % for this HE line only (does not
 * change Fuel Management or the resource). Same key as Daily Log.
 */
export const FUEL_SURCHARGE_OVERRIDE_PERMISSION = 'fuel:custom_surcharge_override';
